"use client";

import CommonSubtitle from "@/components/common/CommonSubtitle";
import Link from "next/link";

type Tcard = {
  title: string;
  subtitle: string;
  url: string;
};

const CommonCard = ({ title, subtitle, url }: Tcard) => {
  return (
    <div className="relative h-full rounded-[8px] border border-[#6049E7]">
      <div className="h-full w-full space-y-5 overflow-hidden rounded-[8px] bg-white px-4 py-6 xlg:h-[180px] xl:px-8 xl:py-4">
        <Link href={url}>
          <div className="flex items-center justify-between">
            <p className="text-[20px] font-semibold text-[#202020]">{title}</p>
            <div className="h-5 w-5">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                className="h-full w-full"
              >
                <path
                  d="M13 10.9998L21.2 2.7998"
                  stroke="#202020"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M22.0031 6.8V2H17.2031"
                  stroke="#202020"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M11 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V13"
                  stroke="#202020"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        </Link>
        <CommonSubtitle color="#202020">{subtitle}</CommonSubtitle>
      </div>
    </div>
  );
};

const MiniCards = () => {
  const cardList = [
    {
      title: "Explore our Blogs",
      subtitle:
        "Read and explore our blogs and articles across various productivity categories.",
      url: "https://kroolo.com/blog",
    },
    {
      title: "Explore Help center",
      subtitle:
        "Explore Knowledge base and articles to learn about the product features.",
      url: "https://help.kroolo.com/",
    },
    {
      title: "Product Videos",
      subtitle:
        "Check our cool product feature video library to get inside feel of the product",
      url: "/videos",
    },
  ];

  return (
    <section className="py-[60px] lg:py-20 xl:py-[120px]">
      <div className="container">
        <div className="mx-auto flex w-full flex-wrap items-center justify-center gap-5 md:grid md:grid-cols-2 md:items-start lg:grid lg:grid-cols-3 xlg:items-center xlg:justify-start xl:max-w-[80%]">
          {cardList.map((item, index) => (
            <CommonCard
              title={item.title}
              subtitle={item.subtitle}
              url={item.url}
              key={index}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default MiniCards;
